import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Grid, Typography, Button } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

import { injuryMappers } from '../../mappers';
import EditAccidentDialog from '../../containers/EditAccidentDialog';
import DeleteOrDeactivateAccidentDialog from '../../containers/DeleteOrDeactivateAccidentDialog';

import { utcToLocal } from './../../utils/timeConverter';
import { branchStatus } from '../../constants';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    marginBottom: theme.spacing(1)
  },
  personnelName: {
    fontSize: 18,
    fontWeight: 'normal',
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(3),
    display: 'inline'
  },
  email: {
    paddingTop: theme.spacing(1),
    display: 'inline'
  },
  deactivateContainer: {
    paddingTop: theme.spacing(2)
  },
  editDeleteContainer: {
    // paddingTop: theme.spacing(1)
  },
  editButton: {
    color: theme.palette.secondary.main
  },
  deleteButton: {
    color: theme.palette.danger.main
  },
  companyDetails: {
    display: 'inline'
  }
}));

const SingleAccident = (props) => {
  const {
    accident,
    handleAccidentEditClick,
    openDeleteOrDeactiveAccidentDialog,
    loggedInUser
  } = props;
  const classes = useStyles();

  const formattedTime = (accident) => {
    const convertedTime = utcToLocal(accident.injuryDate);
    let secondes = convertedTime.get('second');
    if (secondes > 0) {
      return convertedTime.format('DD/MM/YYYY hh:mm A');
    } else {
      return convertedTime.format('DD/MM/YYYY');
    }
  };

  return (
    <React.Fragment>
      <Paper>
        <div className={classes.container}>
          <Grid container>
            <Grid item xs={6}>
              <div className={classes.companyDetails}>
                <Typography variant="h3" className={classes.personnelName}>
                  {accident &&
                    injuryMappers.mapInjuryTypeToText(accident.injuryTypeId)}
                </Typography>
                <Typography variant="subtitle1" className={classes.email}>
                  {accident && formattedTime(accident)}
                </Typography>
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.deactivateContainer}>
                {/* <Button
                  startIcon={<BlockIcon />}
                  onClick={() =>
                    openDeleteOrDeactiveAccidentDialog(true, { ...accident })
                  }
                >
                  Deactivate
                </Button> */}
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.editDeleteContainer}>
                <Button
                  startIcon={<EditIcon />}
                  className={classes.editButton}
                  onClick={() =>
                    handleAccidentEditClick({ ...accident }, loggedInUser)
                  }
                >
                  Accident Detail
                </Button>
                <br />
                <Button
                  startIcon={<DeleteOutlineIcon />}
                  className={classes.deleteButton}
                  onClick={() =>
                    openDeleteOrDeactiveAccidentDialog(
                      true,
                      { ...accident },
                      branchStatus.DELETE
                    )
                  }
                >
                  Delete
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </Paper>
    </React.Fragment>
  );
};

const AccidentsList = (props) => {
  const {
    fetchAllAccidentsForBranch,
    branchId,
    accidents,
    handleAccidentEditClick,
    openDeleteOrDeactiveAccidentDialog,
    loggedInUser
  } = props;
  const classes = useStyles();

  React.useEffect(
    () => {
      if (branchId) {
        fetchAllAccidentsForBranch(branchId);
      }
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [branchId]
  );

  accidents.sort((a, b) => {
    return new Date(b.injuryDate) - new Date(a.injuryDate);
  });

  return (
    <React.Fragment>
      <EditAccidentDialog />
      <DeleteOrDeactivateAccidentDialog />

      <div className={classes.accidentsListContainer}>
        {accidents &&
          accidents.map((accident) => {
            return (
              <SingleAccident
                accident={accident}
                key={accident.id}
                handleAccidentEditClick={handleAccidentEditClick}
                openDeleteOrDeactiveAccidentDialog={
                  openDeleteOrDeactiveAccidentDialog
                }
                loggedInUser={loggedInUser}
              />
            );
          })}
      </div>
    </React.Fragment>
  );
};

export default AccidentsList;
